module.exports = __webpack_public_path__ + "static/img/title.deace784.png";